import React from "react";
import { ThreeDots } from "react-loader-spinner";

const LoadingDots = ({ className, style }) => {
  return (
    <div className={className || ""} style={style || {}}>
      <ThreeDots
        width="100"
        color="#005683"
        ariaLabel="three-dots-loading"
        wrapperClass="d-flex justify-content-center"
      />
    </div>
  );
};

export default LoadingDots;
